<div *ngIf="visita">
    <p>{{'riepilogoPrenotazione.titolo' | translate}}: </p>
    <span class="mb-10 d-block"><strong>{{ visita.titolo | uppercase}}</strong></span>
    <span *ngFor="let opzione of carrello.opzioniSelezionate" class="riepilogoExtra">
        + {{opzione.qta}}X {{opzione.descrizione}}
    </span>
    <span *ngFor="let gita of carrello.giteSelezionate" class="riepilogoExtra">
        + {{gita.qta}}X {{gita.descrizione}}
    </span>
    <br>
    <div>
        <div>
            <div class="row">
                <span class="material-symbols-outlined" matTooltip="{{'riepilogoPrenotazione.dataora' | translate}}">
                    event
                </span>
                <span>
                    {{visita.data | localizedDate: 'shortDate'}} - {{visita.data | localizedDate: 'shortTime'}}<br>
                </span>
            </div>
            <div class="row">
                <span class="material-symbols-outlined" matTooltip="{{'step1.lingua' | translate}}">
                    translate
                </span>
                <span *ngFor="let lingua of visita.lingua.split(';')">
                    {{ lingua | lowercase | translate }}
                </span>
            </div>

            <div class="row">
                <span class="material-symbols-outlined"
                    matTooltip="{{'riepilogoPrenotazione.partecipanti' | translate}}">
                    people
                </span>
                <span *ngIf="carrello.nadulti">
                    {{'riepilogoPrenotazione.adulti' | translate}}:
                    {{carrello.nadulti}}
                </span>
                <span *ngIf="carrello.nridotti">
                    {{'riepilogoPrenotazione.ridotti' | translate}}:
                    {{carrello.nridotti}}
                </span>
                <span *ngIf="carrello.nminori">
                    {{'riepilogoPrenotazione.minori' | translate}}:
                    {{carrello.nminori}}
                </span>
            </div>

            <div class="row">
                <span class="material-symbols-outlined" matTooltip="{{'step1.totale' | translate}}">
                    euro_symbol
                </span>
                <span>
                    {{ totale | number:'1.2-2'}}
                </span>
            </div>
            <div class="row" *ngIf="cantinaSC && visita.supplementoattivo === '1' ">
                <span>(di cui €{{supplemento | number:'1.2-2'}} di supplemento)</span>
            </div>
        </div>
        <div>
            <img src="{{ visita.imgsrc }}" class="imgTipoVisitaRiepilogo" alt="">
        </div>
    </div>
    <div class="row" *ngIf="visita.confermabile === '1'" class="confermabile">
        <span class="material-symbols-outlined" matTooltip="{{'step1.confermabile' | translate}}">
            notifications_active
        </span>
        <span>
            {{'step1.confermabileinfo' | translate}}
        </span>
    </div>
</div>